import { TMainPageLayoutV3 } from "../type";


type TMNPG042 = {
    children:any
}

const MNPG042 = ( props: TMainPageLayoutV3<TMNPG042> ) => {
    console.log("MNPG042.rendered: ", props);

    if ( !props.children ) return null;

    return (
        <section className="section-padding-2">
            <div className="container">
                <div className="single-blog-post">
                    {props.children}
                </div>
            </div>
        </section>
    )
}

export default MNPG042;
